import loader from '@loadable/component';
//@ts-ignore
import { tw } from '@careinfo/tailwind';

const SmsCampaignComponent = loader(
  () => import('../../components/SmsCampaign/SmsCampaign')
);
const SmsCampaign = () => {
  return (
    <>
      <div className={tw`pb-2`}>
        <h1 className={tw`text-lg font-semibold`}>SMS Campaign</h1>
      </div>
      <SmsCampaignComponent />
    </>
  );
};

export default SmsCampaign;
